import { isBrainBodyMSK } from "./brandingConfig";

/**
 * Returns the appropriate logo path based on the current domain
 * @returns {string} The path to the logo file
 */
export const getLogoPath = (): string => {
  return isBrainBodyMSK() ? "/images/BrainBodyMSKLogo.svg" : "/images/logo.svg";
};
